<template>
  <div>
    <div class="page-title">Microsoft Clarity Settings</div>
    <TextField placeholder="" label="Tag" v-model="localValue.data.tag" />
  </div>
</template>

<script>
import mixin from "./addon-form.mixin";

export default {
  extends: mixin,
};
</script>

<style scoped lang="scss"></style>
